import {
  LazyLoadingHandler_default
} from "./chunk.ZXFS3F4J.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  e,
  n,
  r as r2
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-location-teaser/jb-location-teaser.scss?inline
var jb_location_teaser_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.swiper-slide h5, .swiper-slide h4 {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

.swiper-slide .time,
.swiper-slide .temperature {
  font-family: var(--theme-font-xlight-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-xlight-weight, 200);
}

.swiper-slide h4 {
  color: rgb(var(--rgb-primary, 20, 30, 85));
  font-size: 1.375rem;
  line-height: 1.75rem;
}
@media (min-width: 1281px) {
  .swiper-slide h4 {
    font-size: 1.75rem;
    line-height: 2.5rem;
  }
}

.swiper-slide h5 {
  color: rgb(var(--rgb-primary, 20, 30, 85));
  font-size: 1.313rem;
  line-height: 2.125rem;
}
@media (min-width: 1281px) {
  .swiper-slide h5 {
    font-size: 1.5rem;
    line-height: 2.25rem;
  }
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

/**
 * Swiper 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */
@font-face {
  font-family: "swiper-icons";
  src: url("data:application/font-woff;charset=utf-8;base64, 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") format("woff");
  font-weight: 400;
  font-style: normal;
}
:root {
  --swiper-theme-color: #007aff;
}

.swiper {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  /* Fix of Webkit flickering */
  z-index: 1;
}

.swiper-vertical > .swiper-wrapper {
  flex-direction: column;
}

.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  box-sizing: content-box;
}

.swiper-android .swiper-slide,
.swiper-wrapper {
  transform: translate3d(0px, 0, 0);
}

.swiper-pointer-events {
  touch-action: pan-y;
}
.swiper-pointer-events.swiper-vertical {
  touch-action: pan-x;
}

.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
}

.swiper-slide-invisible-blank {
  visibility: hidden;
}

/* Auto Height */
.swiper-autoheight,
.swiper-autoheight .swiper-slide {
  height: auto;
}
.swiper-autoheight .swiper-wrapper {
  align-items: flex-start;
  transition-property: transform, height;
}

.swiper-backface-hidden .swiper-slide {
  transform: translateZ(0);
  backface-visibility: hidden;
}

/* 3D Effects */
.swiper-3d, .swiper-3d.swiper-css-mode .swiper-wrapper {
  perspective: 1200px;
}
.swiper-3d .swiper-wrapper,
.swiper-3d .swiper-slide,
.swiper-3d .swiper-slide-shadow,
.swiper-3d .swiper-slide-shadow-left,
.swiper-3d .swiper-slide-shadow-right,
.swiper-3d .swiper-slide-shadow-top,
.swiper-3d .swiper-slide-shadow-bottom,
.swiper-3d .swiper-cube-shadow {
  transform-style: preserve-3d;
}
.swiper-3d .swiper-slide-shadow,
.swiper-3d .swiper-slide-shadow-left,
.swiper-3d .swiper-slide-shadow-right,
.swiper-3d .swiper-slide-shadow-top,
.swiper-3d .swiper-slide-shadow-bottom {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
}
.swiper-3d .swiper-slide-shadow {
  background: rgba(0, 0, 0, 0.15);
}
.swiper-3d .swiper-slide-shadow-left {
  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}
.swiper-3d .swiper-slide-shadow-right {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}
.swiper-3d .swiper-slide-shadow-top {
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}
.swiper-3d .swiper-slide-shadow-bottom {
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

/* CSS Mode */
.swiper-css-mode > .swiper-wrapper {
  overflow: auto;
  scrollbar-width: none; /* For Firefox */
  -ms-overflow-style: none; /* For Internet Explorer and Edge */
}
.swiper-css-mode > .swiper-wrapper::-webkit-scrollbar {
  display: none;
}
.swiper-css-mode > .swiper-wrapper > .swiper-slide {
  scroll-snap-align: start start;
}

.swiper-horizontal.swiper-css-mode > .swiper-wrapper {
  scroll-snap-type: x mandatory;
}

.swiper-vertical.swiper-css-mode > .swiper-wrapper {
  scroll-snap-type: y mandatory;
}

.swiper-centered > .swiper-wrapper::before {
  content: "";
  flex-shrink: 0;
  order: 9999;
}
.swiper-centered.swiper-horizontal > .swiper-wrapper > .swiper-slide:first-child {
  margin-inline-start: var(--swiper-centered-offset-before);
}
.swiper-centered.swiper-horizontal > .swiper-wrapper::before {
  height: 100%;
  width: var(--swiper-centered-offset-after);
}
.swiper-centered.swiper-vertical > .swiper-wrapper > .swiper-slide:first-child {
  margin-block-start: var(--swiper-centered-offset-before);
}
.swiper-centered.swiper-vertical > .swiper-wrapper::before {
  width: 100%;
  height: var(--swiper-centered-offset-after);
}
.swiper-centered > .swiper-wrapper > .swiper-slide {
  scroll-snap-align: center center;
  scroll-snap-stop: always;
}

.swiper-fade.swiper-free-mode .swiper-slide {
  transition-timing-function: ease-out;
}
.swiper-fade .swiper-slide {
  pointer-events: none;
  transition-property: opacity;
}
.swiper-fade .swiper-slide .swiper-slide {
  pointer-events: none;
}
.swiper-fade .swiper-slide-active, .swiper-fade .swiper-slide-active .swiper-slide-active {
  pointer-events: auto;
}

:host {
  display: block;
}

.swiper-slide {
  padding-block: 128px;
  position: relative;
}
@media (min-width: 600px) {
  .swiper-slide {
    padding-block: 171px 173px;
  }
}
@media (min-width: 1281px) {
  .swiper-slide {
    padding-block: 151px 165px;
  }
}
.swiper-slide jb-picture {
  filter: brightness(0.7);
  inset: 0;
  position: absolute;
  z-index: 1;
}
.swiper-slide jb-picture::part(picture) {
  width: 100vw;
}
.swiper-slide .content {
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 2;
}
.swiper-slide .info {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  margin-top: 40px;
}
@media (min-width: 600px) {
  .swiper-slide .info {
    flex-direction: row;
  }
}
.swiper-slide h4 {
  color: #fff;
  position: relative;
  text-transform: uppercase;
  z-index: 1;
  font-size: 22px;
  font-size: 1.375rem;
  line-height: 28px;
  line-height: 1.75rem;
  letter-spacing: 3px;
  letter-spacing: 0.1875rem;
}
.swiper-slide h5 {
  color: #fff;
  display: inline-block;
  margin: 5px 0;
  max-width: 100%;
  position: relative;
  text-align: center;
  width: 100%;
  z-index: 1;
}
@media (min-width: 600px) {
  .swiper-slide h5 {
    margin: unset;
    max-width: 120px;
  }
}
@media (min-width: 960px) {
  .swiper-slide h5 {
    font-size: 21px;
    font-size: 1.3125rem;
    letter-spacing: 0;
    letter-spacing: 0;
  }
}
.swiper-slide .time,
.swiper-slide .temperature {
  color: #fff;
  position: relative;
  text-align: center;
  white-space: nowrap;
  z-index: 1;
  font-size: 70px;
  font-size: 4.375rem;
  line-height: 80px;
  line-height: 5rem;
}
@media (min-width: 600px) {
  .swiper-slide .time,
  .swiper-slide .temperature {
    font-size: 90px;
    font-size: 5.625rem;
    line-height: 100px;
    line-height: 6.25rem;
  }
}
@media (min-width: 960px) {
  .swiper-slide .time,
  .swiper-slide .temperature {
    font-size: 90px;
    font-size: 5.625rem;
    line-height: 100px;
    line-height: 6.25rem;
  }
}
@media (min-width: 1281px) {
  .swiper-slide .time,
  .swiper-slide .temperature {
    font-size: 110px;
    font-size: 6.875rem;
    line-height: 120px;
    line-height: 7.5rem;
    letter-spacing: 0;
    letter-spacing: 0;
  }
}
.swiper-slide .time:first-of-type,
.swiper-slide .temperature:first-of-type {
  margin-right: 10px;
}
@media (max-width: 599px) {
  .swiper-slide .time:first-of-type,
  .swiper-slide .temperature:first-of-type {
    margin-right: 0;
  }
}
.swiper-slide .time:last-of-type,
.swiper-slide .temperature:last-of-type {
  margin-left: 10px;
}
@media (max-width: 599px) {
  .swiper-slide .time:last-of-type,
  .swiper-slide .temperature:last-of-type {
    margin-left: 0;
  }
}`;

// src/components/jb-location-teaser/jb-location-teaser.ts
var JbLocationTeaser = class extends h {
  async firstUpdated() {
    this._currentTime = /* @__PURE__ */ new Date();
    setInterval(() => {
      this._currentTime = /* @__PURE__ */ new Date();
    }, 2e3);
    LazyLoadingHandler_default.observe(
      this,
      async () => {
        const { default: Swiper, Autoplay, EffectFade } = await import("./swiper.esm.LMNLSJOR.js");
        new Swiper(this._swiper, {
          modules: [EffectFade, Autoplay],
          spaceBetween: 0,
          speed: 1e3,
          effect: "fade",
          autoplay: {
            delay: 3e3,
            disableOnInteraction: false
          }
        });
      },
      "approachingViewport"
    );
  }
  render() {
    return ke`
      <div class="swiper">
        <div class="swiper-wrapper">
          ${this.items.map(
      (item) => ke` <div class="swiper-slide">
                <jb-picture
                  .imgData=${item.image.imgData}
                  .alt=${item.image.alt}
                  fit="cover"
                  lazy="true"
                ></jb-picture>
                <div class="content">
                  <h4>${item.city}</h4>
                  <div class="info">
                    <div class="time">
                      ${this._currentTime?.toLocaleTimeString("de-CH", { timeZone: item.timezone, timeStyle: "short" })}
                    </div>
                    <h5>${item.weather}</h5>
                    <div class="temperature">${item.temperature}</div>
                  </div>
                  ${item.button ? ke` <jb-button-primary
                        .link=${item.button.link}
                        inverted="true"
                        >${item.button.text}
                      </jb-button-primary>` : D}
                </div>
              </div>`
    )}
        </div>
      </div>
    `;
  }
};
JbLocationTeaser.styles = r(jb_location_teaser_default);
__decorateClass([
  n({ type: Array })
], JbLocationTeaser.prototype, "items", 2);
__decorateClass([
  r2()
], JbLocationTeaser.prototype, "_currentTime", 2);
__decorateClass([
  e(".swiper")
], JbLocationTeaser.prototype, "_swiper", 2);
JbLocationTeaser = __decorateClass([
  customElement("jb-location-teaser")
], JbLocationTeaser);

export {
  JbLocationTeaser
};
